export const CustomerStateType = [
    {
        "id": "NEW",
        "name": "Mới",
        "labelCss": "badge bg-primary text-white",
        "buttonCss": "col-md-1 col-1 customer_state_potential border-1-s ml-2 mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none position",
    },
    {
        "id": "PEOPLE_IN_CHARGE",
        "name": "Đã phân công",
        "labelCss": "badge badge-info text-white",
        "buttonCss": "col-md-1 col-1 customer_state_potential border-1-s ml-2 mr-2 background-btn type-button-fix btn btn-info btn-sm shadow-none position",
    },
    {
        "id": "POTENTIAL",
        "name": "Tiềm năng",
        "labelCss": "badge badge-warning text-white",
        "buttonCss": "col-md-1 col-1 customer_state_potential border-1-s mr-2 background-btn type-button-fix btn btn-warning btn-sm shadow-none position",
    },
    {
        "id": "APPOINTMENT",
        "name": "Hẹn gặp",
        "labelCss": "badge badge-danger text-white",
        "buttonCss": "col-md-1 col-1 customer_state_appointment border-1-s mr-2 background-btn type-button-fix btn btn-danger btn-sm shadow-none position",
    },
    {
        "id": "REGISTERED",
        "name": "Đã đăng ký",
        "labelCss": "badge badge-success text-white",
        "buttonCss": "col-md-1 col-1 customer_state_registered border-1-s mr-2 background-btn type-button-fix btn btn-info btn-sm shadow-none position",
    },
    {
        "id": "BOOKED",
        "name": "Hoàn thành giữ chỗ",
        "labelCss": "badge bg-success text-white",
        "buttonCss": "col-md-1 col-1 customer_state_booked border-1-s mr-2 type-button-fix btn btn-success btn-sm shadow-none position",
    },
    {
        "id": "PROFILED",
        "name": "Đã nhập học",
        "labelCss": "badge bg-primary text-white",
        "buttonCss": "col-md-1 col-3 customer_state_profiled border-1-s mr-2 type-button-fix btn btn-primary btn-sm shadow-none position",
    },
    {
        "id": "CONSIDER",
        "name": "Cân nhắc",
        "labelCss": "badge badge-secondary text-white",
        "buttonCss": "col-md-1 col-1 customer_state_potential border-1-s ml-2 mr-2 background-btn type-button-fix btn btn-secondary btn-sm shadow-none position",
    },
    {
        "id": "REJECT_SCHOOL",
        "name": "Từ chối từ trường",
        "labelCss": "badge badge-secondary text-white",
        "buttonCss": "col-md-1 col-1 customer_state_potential border-1-s ml-2 mr-2 background-btn type-button-fix btn btn-secondary btn-sm shadow-none position",
    },
    {
        "id": "REJECT",
        "name": "Từ chối từ PH",
        "labelCss": "badge badge-danger text-white",
        "buttonCss": "col-md-1 col-1 customer_state_potential border-1-s ml-2 mr-2 background-btn type-button-fix btn btn-danger btn-sm shadow-none position",
    },
    {
        "id": "REJECT_TEST",
        "name": "Từ chối Test",
        "labelCss": "badge badge-danger text-white",
        "buttonCss": "col-md-1 col-1 customer_state_potential border-1-s ml-2 mr-2 background-btn type-button-fix btn btn-danger btn-sm shadow-none position",
    },
    {
        "id": "REJECT_ADMISSION",
        "name": "Từ chối nhập học",
        "labelCss": "badge badge-danger text-white",
        "buttonCss": "col-md-1 col-1 customer_state_potential border-1-s ml-2 mr-2 background-btn type-button-fix btn btn-danger btn-sm shadow-none position",
    },
    {
        "id": "RETURN_RESULT",
        "name": "Đã trả kết quả",
        "labelCss": "badge bg-success text-white",
        "buttonCss": "col-md-1 col-1 customer_state_booked border-1-s mr-2 type-button-fix btn btn-success btn-sm shadow-none position",
    },
    {
        "id": "TESTED",
        "name": "Đã kiểm tra",
        "labelCss": "badge badge-warning text-white",
        "buttonCss": "col-md-1 col-1 customer_state_registered border-1-s mr-2 background-btn type-button-fix btn btn-info btn-sm shadow-none position",
    },
]